<div class="header">
  <h2>Gestione <strong>Checklist</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li>Checklist</li>
      <li class="active">Gestione Checklist</li>
    </ol>
  </div>
</div>
<div class="row">
  <div class="col-lg-12 portlets">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-table"></i> Lista <strong>Checklist</strong></h3>
      </div>
      <div class="panel-content">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2" style="padding-top: 5px;">
            <label for="items-per-page">Mostra</label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-3">
            <div class="form-group">
              <input [(ngModel)]="paginationConfig.itemsPerPage" (change)="paginationConfig.currentPage = 1"
                     class="form-control input-sm form-white"
                     id="items-per-page" name="items-per-page" type="number">
            </div>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-3" style="padding-top: 5px;">
            <label for="items-per-page">{{ paginationConfig.itemsPerPage > 1 ? 'risultati' : 'risultato' }}</label>
          </div>
          <div class="col-md-5 col-md-offset-1 col-sm-5 col-sm-offset-1 col-xs-12">
            <div class="row">
              <div class="col-md-3 col-sm-3 col-xs-2" style="padding-top: 5px;">
                <label for="user-filter">
                  Cerca:
                </label>
              </div>
              <div class="col-md-9 col-sm-9 col-xs-10">
                <input [(ngModel)]="checklistFilterValue" class="form-control input-sm form-white"
                       id="user-filter" name="user-filter" type="text">
              </div>
            </div>
          </div>
        </div>
        <div style="overflow-x:auto;">
          <table class="table table-hover">
            <thead>
            <tr>
              <th style="width: 50%;">
                Titolo
                <div class="form-group hidden-xs">
                  <div class="col-sm-10 prepend-icon">
                    <input [(ngModel)]="checklistTitleFilterValue" type="text" class="form-control form-white" placeholder="Cerca Titolo...">
                    <i class="icon-magnifier"></i>
                  </div>
                </div></th>
              <th style="width: 30%;">
                Descrizione
                <div class="form-group hidden-xs">
                  <div class="col-sm-10 prepend-icon">
                    <input [(ngModel)]="checklistDescriptionFilterValue" type="text" class="form-control form-white" placeholder="Cerca Descrizione...">
                    <i class="icon-magnifier"></i>
                  </div>
                </div>
              </th>
              <th class="text-right" style="width: 20%;">Azioni</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let checklist of checklists |
                  checklistFilter: checklistFilterValue |
                  checklistTitleFilter: checklistTitleFilterValue |
                  checklistDescriptionFilter: checklistDescriptionFilterValue |
                  paginate: paginationConfig">
              <td>{{ checklist.name }} </td>
              <td>{{ checklist.description }}</td>
              <td class="text-right">
                <a class="edit btn btn-sm btn-primary"
                   [routerLink]="['/checklist/' + checklist.id_checklist]"
                   mat-raised-button
                   matTooltip="Dettaglio"
                   matTooltipPosition="above">
                  <i class="icon-info"></i></a>
                <a class="edit btn btn-sm btn-default"
                   [routerLink]="['/checklist/update/' + checklist.id_checklist]"
                   mat-raised-button
                   matTooltip="Modifica"
                   matTooltipPosition="above">
                  <i class="icon-note"></i></a>
                <a class="delete btn btn-sm btn-danger"
                   (click)="openDeleteChecklistModal(checklist)"
                   mat-raised-button
                   matTooltip="Elimina"
                   matTooltipPosition="above">
                  <i class="icons-office-57"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <pagination-controls [maxSize]="paginationParams.maxSize"
                             [autoHide]="paginationParams.autoHide"
                             [responsive]="paginationParams.responsive"
                             [previousLabel]="paginationLabels.previousLabel"
                             [nextLabel]="paginationLabels.nextLabel"
                             [screenReaderPaginationLabel]="paginationLabels.screenReaderPaginationLabel"
                             [screenReaderPageLabel]="paginationLabels.screenReaderPageLabel"
                             [screenReaderCurrentLabel]="paginationLabels.screenReaderCurrentLabel"
                             (pageChange)="onPageChange($event)"
                             (pageBoundsCorrection)="onPageBoundsCorrection($event)"
        ></pagination-controls>
      </div>
    </div>
  </div>
</div>
